import { Button } from "antd";
import React from "react";
import { Link } from "react-router-dom";

const InventoryHomeWebsite = () => {
  return (
    <>
      <Link to="/login">
        <Button type="primary">Sign In</Button>
      </Link>
      <Link to="/inventory/signup">
        <Button type="primary">Sign Up</Button>
      </Link>
    </>
  );
};

export default InventoryHomeWebsite;
